import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isPc: 1,
    bHeight:0,
    menuList:[],
    footer:{},
    baseUrl:""
  },

  mutations:{
    setIspc(state,num){
        state.isPc=num
    },
    setBheight(state,num){
      state.bHeight=num
  },
    setMenu(state,list){
      state.menuList=list
    },
    setFooter(state,list){
      state.footer=list
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js